import { drupalComponent } from '@nech/src/helpers/drupal-component';

(function (Drupal, $) {
  drupalComponent('modal_search', {
    selector: '.modal-search--container',
    shared: {
      displayModal: function ($el: JQuery<HTMLElement>) {
        $el.removeClass('opacity-0').addClass('opacity-1');
        $el.removeClass('-z-[1]');
        $el.removeClass('-translate-y-full');
        $el.attr('aria-hidden', 'false');
      },

      hideModal: function ($el: JQuery<HTMLElement>) {
        $el.removeClass('opacity-1').addClass('opacity-0');
        $el.addClass('-translate-y-full');
        $el.addClass('-z-[1]');
        $el.attr('aria-hidden', 'true');
      },
    },

    attach() {
      const self = this;
      const $el = $(this.selector);
      const $searchField = $el.find('.nech-global-searchfield');
      const $dropdown = $el.find('.modal-search--dropdown');
      const numberCharsTrigger = 3;
      const searchBaseUrlApi = $el.data('search-base-url-api');
      const searchBaseUrl = $el.data('search-base-url');
      const $dropdownList = $('.nech-dropdown-list');

      type responseData = {
        title: string;
        url: string;
        type: string;
      };

      type results = [
        {
          node: responseData[];
          file: responseData[];
          object: responseData[];
        },
      ];

      type SearchResults = {
        results: results;
        totalResults: number;
      };

      async function fetchSearchResults(query: string): Promise<SearchResults> {
        try {
          const encodedQuery = encodeURIComponent(query);

          const ResponseTypeNode = await fetch(
            `${searchBaseUrlApi}/${encodedQuery}/node/all/autocomplete.json`,
          );
          const ResponseTypeFile = await fetch(
            `${searchBaseUrlApi}/${encodedQuery}/media/file/autocomplete.json`,
          );
          const ResponseTypeObject = await fetch(
            `${searchBaseUrlApi}/${encodedQuery}/media/object/autocomplete.json`,
          );

          if (!ResponseTypeNode.ok && !ResponseTypeFile.ok && !ResponseTypeObject.ok) {
            throw new Error('Erreur lors de la récupération des résultats.');
          }

          const dataNode = await ResponseTypeNode.json();
          const dataFile = await ResponseTypeFile.json();
          const dataObject = await ResponseTypeObject.json();

          const totalResults =
            dataNode.pager.total_results +
            dataFile.pager.total_results +
            dataObject.pager.total_results;

          const nodeResults = dataNode.results.map(
            (item: { title: string; url: string; type: string }) => ({
              title: item.title,
              url: item.url,
              type: item.type,
            }),
          );
          const fileResuts = dataFile.results.map(
            (item: { title: string; url: string; type: string }) => ({
              title: item.title,
              url: item.url,
              type: item.type,
            }),
          );
          const objectResults = dataObject.results.map(
            (item: { title: string; url: string; type: string }) => ({
              title: item.title,
              url: item.url,
              type: item.type,
            }),
          );

          const results: results = [
            {
              node: nodeResults,
              file: fileResuts,
              object: objectResults,
            },
          ];

          return {
            results,
            totalResults,
          };
        } catch (error) {
          console.error('Erreur API :', error);
          return {
            results: [
              {
                node: [],
                file: [],
                object: [],
              },
            ],
            totalResults: 0,
          };
        }
      }

      let previousDropdownHeight = $dropdownList.outerHeight();

      function checkDropdownHeight() {
        const currentDropdownHeight = $dropdownList.outerHeight();
        const lastLi = $dropdownList.find('li').last();

        if (currentDropdownHeight && currentDropdownHeight >= lastLi.position().top) {
          $dropdownList.addClass('has-not-scroll');
        } else {
          $dropdownList.removeClass('has-not-scroll');
        }

        previousDropdownHeight = currentDropdownHeight;
      }

      $dropdownList.on('scroll', function (e) {
        const lastLi = $(this).find('li').last();
        const clientHeight = e.target.clientHeight;

        checkDropdownHeight();

        if (lastLi.position().top <= clientHeight) {
          $(this).addClass('has-not-scroll');
        } else {
          $(this).removeClass('has-not-scroll');
        }
      });

      $searchField.on('input', async function () {
        const inputValue = $(this).children().val();
          if (typeof inputValue !== 'string' || inputValue.trim().length < numberCharsTrigger) {
          // Vider et cacher le dropdown immédiatement sans attendre fetch
          const $dropdownNodesSection = $dropdown.children().find('.pages-content-results');
          const $dropdownFilesSection = $dropdown.children().find('.files-content-results');
          const $dropdownObjectSection = $dropdown.children().find('.objects-content-results');

          $dropdownList.addClass('has-not-scroll');
          $dropdownNodesSection.html('');
          $dropdownFilesSection.html('');
          $dropdownObjectSection.html('');
          $dropdownList.find('.nech-dropdown-list--see-all-link').attr('aria-hidden', 'true');
          self.shared.hideModal($dropdown);
          return; // ⚠️ ne fait PAS d'appel API
        }
        if (typeof inputValue === 'string') {
          const { results: suggestions, totalResults } = await fetchSearchResults(inputValue);
          const node = suggestions[0].node.length > 0;
          const file = suggestions[0].file.length > 0;
          const object = suggestions[0].object.length > 0;
          const $dropdownFilesSection = $dropdown.children().find('.files-content-results');
          const $dropdownNodesSection = $dropdown.children().find('.pages-content-results');
          const $dropdownObjectSection = $dropdown.children().find('.objects-content-results');
          if ((node || file || object) && inputValue.trim().length >= numberCharsTrigger) {
            setTimeout(() => {
              checkDropdownHeight();
            }, 0);

            $dropdownNodesSection.html('');
            $dropdownFilesSection.html('');
            $dropdownObjectSection.html('');
            const titleNodeSection = `<p class="paragraph-xs text-neutral-600 mt-3">${Drupal.t('Page(s)')}</p>`;
            const titleFileSection = `<p class="paragraph-xs text-neutral-600 mt-3">${Drupal.t('Document(s)')}</p>`;
            const titleObjectSection = `<p class="paragraph-xs text-neutral-600 mt-3">${Drupal.t('Objet(s) du Grand Conseil')}</p>`;

            $dropdownList
              .find('.nech-dropdown-list--see-all-link')
              .text(`${Drupal.t('Voir tous les résultats')} (${totalResults})`);
            $dropdownList
              .find('.nech-dropdown-list--see-all-link')
              .attr('href', `${searchBaseUrl}/${inputValue}`);
            $dropdownList.find('.nech-dropdown-list--see-all-link').attr('aria-hidden', 'false');

            if (
              (!node && !file && !object) ||
              (!node && !file && object) ||
              (!node && file && !object) ||
              (node && !file && !object)
            ) {
              $dropdownNodesSection.removeClass('border-b border-b-solid border-b-neutral-200');
              $dropdownFilesSection.removeClass('border-b border-b-solid border-b-neutral-200');
            }

            if (!node && file && object) {
              $dropdownFilesSection.addClass('border-b border-b-solid border-b-neutral-200');
              $dropdownNodesSection.removeClass('border-b border-b-solid border-b-neutral-200');
            }

            if (node && !file && object) {
              $dropdownNodesSection.addClass('border-b border-b-solid border-b-neutral-200');
              $dropdownFilesSection.removeClass('border-b border-b-solid border-b-neutral-200');
            }

            if (node && file && !object) {
              $dropdownNodesSection.addClass('border-b border-b-solid border-b-neutral-200');
              $dropdownFilesSection.removeClass('border-b border-b-solid border-b-neutral-200');
            }

            if (node && file && object) {
              $dropdownNodesSection.addClass('border-b border-b-solid border-b-neutral-200');
              $dropdownFilesSection.addClass('border-b border-b-solid border-b-neutral-200');
            }

            if (suggestions[0].file.length) {
              $dropdownFilesSection.append(titleFileSection);
              suggestions[0].file.forEach((item: responseData) => {
                const dropdownFilesItem = `<li class="flex gap-3 p-3 text-primary-700 bg-neutral-100 rounded-250 self-start cursor-pointer hover:bg-neutral-200 transition-all duration-200 "><span class="ph ph-file text-2xl"></span><a href="${item.url}" target="_blank" class="dropdown-item focus-primary-700 flex flex-col mt-[8px] paragraph-xs" aria-label="ouvrir dans un nouvel onglet suggestion de résultat de document ${item.title}">${item.title}</a></li>`;
                $dropdownFilesSection.append(dropdownFilesItem);
              });
            }
            if (suggestions[0].node.length) {
              $dropdownNodesSection.append(titleNodeSection);
              suggestions[0].node.forEach((item: responseData) => {
                const dropdownNodeItem = `<li><a href="${item.url}" class="dropdown-item flex flex-col mt-[8px] text-neutral-950 paragraph-xs cursor-ponter hover:underline focus-primary-700 " aria-label="suggestion de résultat de contenu ${item.title}">${item.title}</a></li>`;
                $dropdownNodesSection.append(dropdownNodeItem);
              });
            }
            if (suggestions[0].object.length) {
              $dropdownObjectSection.append(titleObjectSection);
              suggestions[0].object.forEach((item: responseData) => {
                const dropdownObjectItem = `<li class="flex gap-3 p-3 text-primary-700 bg-neutral-100 rounded-250 self-start cursor-pointer hover:bg-neutral-200 transition-all duration-200 "><span class="ph ph-file text-2xl"></span><a href="${item.url}" target="_blank" class="dropdown-item focus-primary-700 flex flex-col mt-[8px] paragraph-xs" aria-label="ouvrir dans un nouvel onglet suggestion de résultat d'objets ${item.title}">${item.title}</a></li>`;
                $dropdownObjectSection.append(dropdownObjectItem);
              });
            }
          }

          if ((node || file || object) && inputValue.trim().length >= numberCharsTrigger) {
            self.shared.displayModal($dropdown);
          } else {
            self.shared.hideModal($dropdown);
          }
        }
      });
    },
  });
})(Drupal, jQuery);
